import React from 'react'

import { useAppSelector } from 'redux/hooks'

import Editor from 'components/formElements/richText/Editor'

import { isEmpty } from 'utils/Deltas'

import styles from './descriptionContainer.module.scss'

type Props = {
  className?: string
}

const DescriptionContainer = ({ className = '' }: Props) => {
  const description = useAppSelector(state => state.deck.description)

  return (
    <div className={`${styles.container} ${className}`}>
      <h2>Description</h2>
      {isEmpty(description) ? (
        <p className={styles.empty}>No description yet.</p>
      ) : (
        <Editor value={description} readOnly />
      )}
    </div>
  )
}

export default DescriptionContainer
